import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: UpdateAdvertiserInput!) {
    updateAdvertiser (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Advertisers/UpdateMutation.js